import React from 'react';
import Input from '../../../components/ui/Input';

const ImagingSection = ({ formData, onChange, errors }) => {
  const handleChange = (field, value) => {
    onChange('imaging', field, value);
  };

  return (
    <div className="glass-card rounded-2xl p-6 hover-glow hover-lift">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-white mb-1">
          Imagerie
        </h2>
        <div className="mt-3 p-4 bg-blue-500/10 border border-blue-500/30 rounded-xl">
          <p className="text-sm text-gray-300 leading-relaxed">
            Pour les CBCT volumineux, utilisez un service de transfert (WeTransfer, SwissTransfer). 
            Incluez le viewer ou les instructions d'ouverture.
          </p>
          <p className="text-sm text-gray-300 leading-relaxed mt-2">
            Sinon, joignez quelques coupes pertinentes en JPG/PNG.
          </p>
        </div>
      </div>
      
      <div className="space-y-4">
        <Input
          label="Lien de téléchargement"
          type="url"
          placeholder="https://wetransfer.com/..."
          value={formData?.imaging?.downloadLink || ''}
          onChange={(e) => handleChange('downloadLink', e?.target?.value)}
          error={errors?.downloadLink}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="Mot de passe"
            type="text"
            placeholder="Si nécessaire"
            value={formData?.imaging?.password || ''}
            onChange={(e) => handleChange('password', e?.target?.value)}
            error={errors?.password}
          />

          <Input
            label="Centre d'imagerie"
            type="text"
            placeholder="Nom du centre"
            value={formData?.imaging?.imagingCenter || ''}
            onChange={(e) => handleChange('imagingCenter', e?.target?.value)}
            error={errors?.imagingCenter}
          />
        </div>
      </div>
    </div>
  );
};

export default ImagingSection;